<template>
  <div
    class="check-grid"
    :class="{ 'selected': isSelected }"
    role="button"
    tabindex="0"
    :aria-pressed="isSelected ? 'true' : 'false'"
    @click="toggleSelection"
    @keydown.enter.prevent="toggleSelection"
    @keydown.space.prevent="toggleSelection"
  >
    <div class="check-grid__label">{{ item.title }}</div>
    <div class="check-grid__odds num">{{ item.value }}</div>
  </div>
</template>

<script>
export default {
  name: 'CheckGrid',
  props: {
    item: {
      type: Object,
      required: true,
      validator: obj => obj.hasOwnProperty('name') && obj.hasOwnProperty('title') && obj.hasOwnProperty('value')
    },
    selectedOddsItems: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    isSelected() {
      // return newSelectedItems.includes(this.item);
      return this.selectedIndex >= 0
    },
    selectedIndex() {
      // let newSelectedItems = [...this.selectedOddsItems];
      const index = this.selectedOddsItems.findIndex((i) => i.name === this.item.name);
      return index;
    }
  },
  methods: {
    toggleSelection() {
      console.log("grid toggle selection:", this.selectedOddsItems, this.item);
      let newSelectedItems = [...this.selectedOddsItems];
      const index = newSelectedItems.findIndex((i) => i.name === this.item.name);
      if (index > -1) {
        newSelectedItems.splice(index, 1);
      } else {
        newSelectedItems.push(this.item);
      }
      // 触发自定义事件，将修改后的数据传递给父组件
      console.log("grid toggle selection emit: ", newSelectedItems);
      this.$emit('selection-change', newSelectedItems);

      // this.selection = !this.isSelected;
      // this.$emit('selection-change', {
      //   item: this.item,
      //   selected: this.selection
      // });
    }
  }
}
</script>

<style scoped>
.check-grid {
  border: 1px solid var(--line);
  cursor: pointer;
  transition: background .12s ease, border-color .12s ease, box-shadow .12s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  user-select: none;
}

.check-grid__label {
  padding: 4px 2px 2px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.check-grid__odds {
  padding: 5px 2px 6px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--ink-soft);
}

.check-grid:hover {
  background: var(--pitch-100);
  border-color: var(--pitch-500);
}

/* selected = the scoreline the user (or an algorithm) picked.
   Light border + inner ring keep adjacent selected cells separated
   (a solid fill alone merges neighbours into one dark block). */
.check-grid.selected {
  background: var(--pitch-600);
  border-color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .55);
  position: relative;
  z-index: 1;
}
.check-grid.selected .check-grid__label {
  color: #fff;
  border-bottom-color: rgba(255, 255, 255, .25);
}
.check-grid.selected .check-grid__odds {
  color: #fff;
  font-weight: 600;
}
</style>